<template>
  <!--
    	作者：luoyiming
    	时间：2019-10-26
    	描述：商品管理-商品编辑-高级设置
    -->
  <div class="basic-setting-content pl16 pr16">
    <!--其他设置-->
    <div class="common-form">其他设置</div>
    <el-form-item label="商品属性：">
      <el-radio-group v-model="form.model.isVirtual">
        <el-radio :label="0">实物商品</el-radio>
        <el-radio :label="1">虚拟商品(无需发货)</el-radio>
        <el-radio :label="2">计次商品(无需发货)</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item  label="运费模板：" prop="model.deliveryId" v-if="form.model.isVirtual==0">
      <el-radio-group v-model="form.model.is_delivery_free" disabled>
        <el-radio :label="0">包邮</el-radio>
        <el-radio :label="1">运费模板</el-radio>
      </el-radio-group>
      <el-select v-model="form.model.deliveryId" v-if="form.model.is_delivery_free == 1" disabled>
        <el-option v-for="item in form.delivery" :value="item.deliveryId" :key="item.deliveryId" :label="item.name"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="初始销量：">
      <el-input type="number" min="0" v-model="form.model.salesInitial" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="商品排序：" :rules="[{ required: true, message: ' ' }]" prop="model.productSort">
      <el-input type="number" min="0" v-model="form.model.productSort" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="限购数量：" :rules="[{ required: true, message: ' ' }]" prop="model.limitNum">
      <el-input type="number" min="0" v-model="form.model.limitNum" class="max-w460"></el-input>
      <div class="gray9">每个会员购买的最大数量，0为不限购</div>
    </el-form-item>
    <el-form-item label="发货类型：" v-if="form.model.isVirtual==1">
      <el-radio-group v-model="form.model.virtualAuto">
        <el-radio :label="1">自动</el-radio>
        <el-radio :label="0">手动</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="虚拟内容：" :rules="[{ required: true, message: '请填写虚拟内容' }]" prop="model.virtualContent" v-if="form.model.isVirtual==1">
      <el-input type="text" v-model="form.model.virtualContent" class="max-w460"></el-input>
      <div class="gray9">虚拟物品内容</div>
    </el-form-item>
    <el-form-item label="会员等级限制：">
      <el-select v-model="form.model.gradeIds" multiple placeholder="请选择" style="width: 460px;">
        <el-option
          v-for="item in form.gradeList"
          :key="item.grade_id"
          :label="item.name"
          :value="item.grade_id">
        </el-option>
      </el-select>
      <div class="gray9">仅设置的等级会员可购买，不设置则都可以购买</div>
    </el-form-item>
    <!--积分设置-->
    <div class="common-form mt50">积分设置</div>
    <el-form-item label="是否开启积分赠送：">
      <el-radio-group v-model="form.model.isPointsGift">
        <el-radio :label="1">开启</el-radio>
        <el-radio :label="0">关闭</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="是否允许使用积分抵扣：">
      <el-radio-group v-model="form.model.isPointsDiscount">
        <el-radio :label="1">允许</el-radio>
        <el-radio :label="0">不允许</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item v-if="form.model.isPointsDiscount == 1" label="最大抵扣积分数量：" :rules="[{ required: true, message: ' ' }]" prop="model.maxPointsDiscount">
      <el-input type="number" min="0" v-model="form.model.maxPointsDiscount" class="max-w460"></el-input>
    </el-form-item>
    <!--会员折扣设置-->
    <div class="common-form mt50">会员折扣设置</div>
    <el-form-item label="是否开启会员折扣：">
      <el-radio-group v-model="form.model.isEnableGrade">
        <el-radio :label="1">开启</el-radio>
        <el-radio :label="0">关闭</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="会员折扣设置：">
      <el-radio-group v-model="form.model.isAloneGrade">
        <el-radio :label="0">默认折扣</el-radio>
        <el-radio :label="1">单独设置折扣</el-radio>
      </el-radio-group>
      <div class="gray9" v-if="form.model.isAloneGrade==0">默认折扣：默认为用户所属会员等级的折扣率</div>
    </el-form-item>

    <el-form-item label="折扣佣金类型：" v-if="form.model.isAloneGrade==1">
      <el-radio-group v-model="form.model.aloneGradeType" @change="changeGradeType">
        <el-radio :label="10">百分比</el-radio>
        <el-radio :label="20">固定金额</el-radio>
      </el-radio-group>
    </el-form-item>

    <el-form-item label="" v-if="form.model.isAloneGrade==1">
      <div class="max-w460">
        <el-table :data="form.gradeList" border size="mini" style="width: 100%">
          <el-table-column prop="name" label="会员等级">
          </el-table-column>
          <el-table-column prop="name" label="折扣">
            <template v-slot="scope">
              <div class="d-s-c">
                <el-input v-model="scope.row.product_equity" type="number" placeholder="请输入折扣"></el-input>
                <span class="ml10">{{ grade_unit }}</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-form-item>
    <!--分销设置-->
    <div class="common-form mt50" v-if="form.basicSetting.is_open == 1">分销设置</div>
    <el-form-item label="是否开启分销：" v-if="form.basicSetting.is_open == 1">
      <el-radio-group v-model="form.model.is_agent">
        <el-radio :label="0">关闭</el-radio>
        <el-radio :label="1">开启</el-radio>
      </el-radio-group>
    </el-form-item>
    <template v-if="form.model.is_agent === 1">
      <el-form-item label="分销规则：" v-if="form.basicSetting.is_open == 1">
        <el-radio-group v-model="form.model.isIndAgent">
          <el-radio :label="0">平台规则</el-radio>
          <el-radio :label="1">单独规则</el-radio>
        </el-radio-group>
        <div class="gray9">平台规则：层级({{form.basicSetting.level}}级)
          <span v-if="form.basicSetting.level >= 1" style="padding-left: 10px;">1级佣金({{form.agentSetting.firstMoney}}%)</span>
          <span v-if="form.basicSetting.level >= 2" style="padding-left: 10px;">2级佣金({{form.agentSetting.secondMoney}}%)</span>
          <span v-if="form.basicSetting.level >= 3" style="padding-left: 10px;">3级佣金({{form.agentSetting.thirdMoney}}%)</span>
        </div>
      </el-form-item>
      <template v-if="form.model.isIndAgent === 1 && form.basicSetting.is_open == 1">
        <el-form-item label="分销佣金类型：">
          <el-radio-group v-model="form.model.agentMoneyType" @change="changeMoneyType">
            <el-radio :label="10">百分比</el-radio>
            <el-radio :label="20">固定金额</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="单独分销设置：">
          <el-input type="number" min="0" v-model="form.model.firstMoney" class="max-w460">
            <template slot="prepend">
              一级佣金：
            </template>
            <template slot="append">
              {{ unit }}
            </template>
          </el-input>
        </el-form-item>
        <el-form-item v-if="form.basicSetting.level >= 2">
          <el-input type="number" min="0" v-model="form.model.secondMoney" class="max-w460">
            <template slot="prepend">
              二级佣金：
            </template>
            <template slot="append">
              {{ unit }}
            </template>
          </el-input>
        </el-form-item>
        <el-form-item v-if="form.basicSetting.level >= 3">
          <el-input type="number" min="0" v-model="form.model.thirdMoney" class="max-w460">
            <template slot="prepend">
              三级佣金：
            </template>
            <template slot="append">
              {{ unit }}
            </template>
          </el-input>
        </el-form-item>
      </template>
    </template>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        unit: '%',
        grade_unit: '%'
      };
    },
    created() {
      if(this.form.model.aloneGradeType == '20'){
        this.grade_unit = '元';
      }
      if(this.form.model.agentMoneyType == '20'){
        this.unit = '元';
      }
    },
    inject: ['form'],
    methods: {
      /*换算单位*/
      changeMoneyType: function(val) {
        if (val == '10') {
          this.unit = '%';
        } else {
          this.unit = '元';
        }
      },
	  /*换算单位*/
	  changeGradeType: function(val) {
	    if (val == '10') {
	      this.grade_unit = '%';
	    } else {
	      this.grade_unit = '元';
	    }
	  }
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/product/product/part/Buyset.1.vue